import { Star } from 'lucide-react';

export default function StrengthCard({ strength }) {
  return (
    <div className="rounded-lg border-l-4 border-green-500 bg-green-50/50 p-4">
      <div className="flex items-start gap-3">
        <Star className="w-5 h-5 text-green-500 mt-0.5 flex-shrink-0" />
        <div>
          <h4 className="font-medium text-bastion-black">{strength.title}</h4>
          <p className="text-sm text-bastion-gray-800 mt-1">{strength.description}</p>
        </div>
      </div>
    </div>
  );
}
